.timi { display: inline-flex; align-items: flex-end; justify-content: center; flex-shrink: 0; touch-action: none; }
.timi svg { overflow: visible; display: block; }
.timi-body { transform-origin: 50% 90px; transform-box: view-box; transition: transform 0.35s cubic-bezier(.3,.7,.3,1); }
.timi-live .timi-body { animation: timi-breathe 3.4s ease-in-out infinite; }
.timi-live.timi-sleepy .timi-body { animation-duration: 5.2s; }
.timi-sway .timi-body { animation: timi-sway 1.8s ease-in-out infinite; }
.timi-jump .timi-body { animation: none; transform: translateY(-16px) scale(0.92, 1.1); }
.timi:not(.timi-sway) svg { transform: rotate(var(--tilt, 0deg)); transform-origin: 50% 90%; transition: transform 0.5s cubic-bezier(.3,1.4,.5,1); }
.timi-interactive { cursor: pointer; }

@keyframes timi-breathe {
  0%, 100% { transform: scale(1.01, 0.98); }
  50% { transform: translateY(-2px) scale(0.99, 1.02); }
}
@keyframes timi-sway {
  0%, 100% { transform: rotate(-4deg); }
  50% { transform: rotate(4deg); }
}

.timi-badge {
  border-radius: 50%;
  background: var(--text);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
